// Bridges "a protected call saw a 401" (transport) to "clear the session"
// (React state). The handler is registered once by AuthContext on mount.

type SessionExpiredHandler = () => void;

let handler: SessionExpiredHandler | null = null;

export function registerSessionExpiredHandler(next: SessionExpiredHandler) {
  handler = next;
  return () => {
    if (handler === next) {
      handler = null;
    }
  };
}

export function notifySessionExpired() {
  handler?.();
}
